import { BaseSectionProps } from "../types/landingSections";

const ServicesSection: React.FC<BaseSectionProps> = ({
    data,
    section,
}) => {

    const companyName =
        data?.company?.name ??
        "Profesional";

    // ✅ LEER DESDE section (como HeroSection)
    const title =
        section?.props?.title ??
        `Servicios de ${companyName}`;

    const subtitle =
        section?.props?.subtitle ??
        "Soluciones diseñadas para ofrecer resultados reales";

    const services =
        section?.props?.items ?? [];

    return (
        <section className="py-20 px-6">
            <div className="max-w-7xl mx-auto">

                {/* HEADER */}
                <div className="text-center mb-16">
                    <h2 className="text-2xl font-bold">
                        {title}
                    </h2>

                    <p className="mt-3 text-lg">
                        {subtitle}
                    </p>
                </div>

                {/* SERVICIOS */}
                <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-10">

                    {services.length === 0 && (
                        <div className="col-span-full text-center text-zinc-800">
                            No hay servicios disponibles
                        </div>
                    )}

                    {services.map(
                        (service: any, index: number) => (
                            <div
                                key={service.id ?? index}
                                className="
                                    group
                                    rounded-[28px]
                                    p-8
                                    bg-white/[0.04]
                                    border border-white/10
                                    backdrop-blur-xl
                                    transition-all duration-300
                                    hover:border-cyan-400/40
                                    hover:shadow-[0_0_25px_rgba(0,255,255,0.2)]
                                    hover:-translate-y-2
                                "
                            >
                                <h3 className="text-xl font-semibold mb-4 group-hover:text-cyan-300 transition">
                                    {service.titulo}
                                </h3>

                                <p className="text-white/70 text-sm leading-relaxed">
                                    {service.descripcion}
                                </p>
                            </div>
                        )
                    )}
                </div>
            </div>
        </section>
    );
};

export default ServicesSection;